// Store links reused from mobile src/constants.ts — the web app has no
// checkout; Pro is purchased in the mobile apps and synced via Firestore.
export const APP_STORE_URL =
  'https://apps.apple.com/app/owlly-transcribe-voice-notes/id6636512281';
export const PLAY_STORE_URL =
  'https://play.google.com/store/apps/details?id=cc.owlly.app';

export const PRIVACY_URL = 'https://owlly.cc/privacy';
export const TERMS_URL = 'https://owlly.cc/terms';
export const FEEDBACK_EMAIL = 'notes@owlly.cc';

// transcribeVoiceMessage rejects payloads over 12MB of base64.
export const MAX_DICTATION_BASE64_BYTES = 12 * 1024 * 1024;
